import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { CreateReference } from 'app/dtos/reference/createReference';
import { UpdateReference } from 'app/dtos/reference/updateReference';

@Injectable({
  providedIn: 'root'
})
export class ReferenceService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllReference(page, size,kindId?:number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Reference,
      queryString: `Page=${page}&Size=${size}&KindId=${kindId}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdReference(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Reference
    }, id);
    return await firstValueFrom(observable);
  }

  async createReference(createReference: CreateReference) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Reference
    },
      {
        min: createReference.min,
        max: createReference.max,
        unitTypeId: createReference.unitTypeId,
        kindId: createReference.kindId
      });
    return await firstValueFrom(observable);
  }

  async updateReference(updateReference: UpdateReference) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Reference
    },
      {
        id: updateReference.id,
        min: updateReference.min,
        max: updateReference.max,
        unitTypeId: updateReference.unitTypeId,
        kindId: updateReference.kindId
      });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
